
import React from 'react';
import { useLocation } from 'react-router-dom';
import { FadeIn } from '@/components/Animations';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface DashboardHeaderProps {
  title?: string;
  description?: string;
  showBackButton?: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ 
  title, 
  description,
  showBackButton = false
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Automatically generate title and description based on route if not provided
  const getDefaultTitle = () => {
    const path = location.pathname;
    
    if (path.includes('integrated-dashboard')) return 'Health Dashboard';
    if (path.includes('cycle-tracking')) return 'Cycle Tracking';
    if (path.includes('symptom-reporting')) return 'Symptom Tracker';
    if (path.includes('leaderboard')) return 'Community & Achievements';
    if (path.includes('profile')) return 'Your Profile';
    
    return 'Hormony';
  };
  
  const getDefaultDescription = () => {
    const path = location.pathname;
    
    if (path.includes('integrated-dashboard')) return 'Your personalized health insights and progress overview';
    if (path.includes('cycle-tracking')) return 'Track and understand your menstrual cycle';
    if (path.includes('symptom-reporting')) return 'Log and analyze your symptoms over time';
    if (path.includes('leaderboard')) return 'Connect with the community and track your achievements';
    if (path.includes('profile')) return 'Manage your personal information and settings';
    
    return 'Your hormone health companion';
  };
  
  const displayTitle = title || getDefaultTitle();
  const displayDescription = description || getDefaultDescription();
  
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-4">
        {showBackButton && (
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={() => navigate(-1)}
            className="mr-2"
          >
            <ArrowLeft size={18} />
          </Button>
        )}
        <h1 className="text-2xl md:text-3xl font-display font-medium">
          {displayTitle}
        </h1>
      </div>
      
      <p className="text-hormony-charcoal/70 max-w-2xl">
        {displayDescription}
      </p>
    </div>
  );
};

export default DashboardHeader;
